import { render, staticRenderFns } from "./create-document-template.vue?vue&type=template&id=203b68a6&scoped=true&"
import script from "./create-document-template.vue?vue&type=script&lang=js&"
export * from "./create-document-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b68a6",
  null
  
)

export default component.exports